function UserAvatar({username}) {
    const initial = Array.from(username?.trim() || 'U')[0].toLocaleUpperCase();

    return (
        <div
            className='flex h-10 w-10 items-center justify-center rounded-full bg-indigo-500 font-bold text-white'
            aria-label={`${username || 'User'} avatar`}
        >
            {initial}
        </div>
    )
}

export default UserAvatar
